import { AggregatedWholeSaleQueryResultDto } from '@app/api/dmc';
import { Columns } from '@shared/interfaces/table/column-config';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const settlementWholesaleTableConfig: Columns<AggregatedWholeSaleQueryResultDto>[]  = [
  {
    title: 'settlement.wholesale.balancesupplieridentification',
    key: 'balanceSupplierIdentification'
  },
  {
    title: 'settlement.wholesale.chargetype',
    key: 'chargeType',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'chargeInformation.chargeTypes.notspecified',
      subscription: 'chargeInformation.chargeTypes.subscription',
      fee: 'chargeInformation.chargeTypes.fee',
      tariff: 'chargeInformation.chargeTypes.tariff'
    }
  },
  {
    title: 'settlement.wholesale.chargetypeid',
    key: 'chargeTypeId',
  },
  {
    title: 'settlement.wholesale.chargeowner',
    key: 'chargeOwnerEnergyParty',
  }
]
